module.exports = __webpack_public_path__ + "img/logo-icon.88cae607.png";